import { Alert, Text } from '@/ui'
import { faRefresh } from '@fortawesome/pro-solid-svg-icons'
import { TypographyStyles } from '@/styles'

export const ReportInProgress = () => {
  return (
    <Alert customIconName={faRefresh} variant="priority">
      <Text variant={TypographyStyles.H3} className="text-left mb-2">
        Report in progress
      </Text>
      <Text variant={TypographyStyles.BODY_SM}>
        Your report will be ready once we&apos;ve categorized your transactions.
      </Text>
    </Alert>
  )
}
